import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'patient', en);

const UpdatePatientConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Patient Management',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PATIENT,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/patient/:id',
      component: React.lazy(() => import('./UpdatePatient')),
    },
  ],
};

export default UpdatePatientConfig;
